const RELOAD_KEY = 'chunk_reload_attempted';

const STALE_ASSET_MESSAGES = [
	'Failed to fetch dynamically imported module',
	'Importing a module script failed',
	'error loading dynamically imported module',
	'Unable to preload CSS',
	'does not provide an export named',
];

/**
 * Reloads the page once when a chunk or CSS file fails to load, which is what
 * a tab still running the previous deployment hits. sessionStorage remembers
 * the attempt so a persistent failure doesn't loop.
 */
export const reloadOnStaleAssets = (error: unknown) => {
	const isStaleAssetError =
		error instanceof Error &&
		STALE_ASSET_MESSAGES.some((message) => error.message?.includes(message));

	if (!isStaleAssetError || typeof window === 'undefined') {
		return;
	}

	// Some in-app browsers (e.g. Facebook's) deny storage access and throw.
	// Without storage the loop guard can't work, so don't reload at all.
	try {
		if (sessionStorage.getItem(RELOAD_KEY)) {
			console.error('Asset loading error persists after reload');
			sessionStorage.removeItem(RELOAD_KEY);
			return;
		}

		sessionStorage.setItem(RELOAD_KEY, 'true');
	} catch {
		return;
	}

	console.warn('Detected stale assets (chunk/CSS), reloading page...');
	window.location.reload();
};
